var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 7C14 9.7614 11.7614 12 9 12C6.2386 12 4 9.7614 4 7C4 4.2386 6.2386 2 9 2C11.7614 2 14 4.2386 14 7ZM2 20V21C2 21.5522 2.4477 22 3 22H15C15.5523 22 16 21.5522 16 21V20C16 17.7908 14.2092 16 12 16H6C3.7908 16 2 17.7908 2 20ZM13.9944 11.8956C14.3195 11.9621 14.6552 12 15 12C17.7614 12 20 9.7614 20 7C20 4.2386 17.7614 2 15 2C14.6552 2 14.3195 2.038 13.9944 2.1044C15.233 3.3678 16 5.0954 16 7C16 8.9046 15.233 10.6321 13.9944 11.8956ZM18 16H16.4595C17.4138 17.0628 18 18.4625 18 20V22H21C21.5523 22 22 21.5522 22 21V20C22 17.7908 20.2092 16 18 16Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.ef83655b9e896549e39137744b847acc.svg";
export { ForwardRef as ReactComponent };